import React from 'react';

export default {
  'cardBuilder.removeCard': <i className="ion-md-remove-circle"/>,
  'cardBuilder.editCard': <i className="ion-md-create"/>,
  'cardBuilder.addCard': <i className="ion-md-add" />,
};
